import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Card, Button, Divider, Typography, Box, Stack } from "@mui/material";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2/Grid2";

const InnerCard = (props) => {
    const { content } = props;
    const navigate = useNavigate();

    const handleClick = (event) => {
        let recordId = content?.id;
        navigate("/projectDetails/" + recordId);
    };

    return (
        <Card sx={{ bgcolor: "#eaf1f8", maxWidth: "100%", px: 2, py: 1 }}>
            <CardHeader
                sx={{
                    px: 0,
                    py: "1px",
                }}
                title={
                    <Grid
                        container
                        sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Grid item>
                            <Typography variant="h3">
                                <strong>{content?.companyName}</strong>
                            </Typography>
                            <Typography variant="body1" sx={{ mt: "5px" }}>
                                {content?.streetAddress}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" size="small" onClick={(e) => handleClick(e)} id="donationOrder">
                                View Details
                            </Button>
                        </Grid>
                    </Grid>
                }
            />
            <Divider sx={{ borderColor: "gray", my: "10px" }}></Divider>
            <CardContent sx={{ py: "1px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Stack direction="row">
                        <Typography variant="body1">
                            Pieces : <strong>{content?.pieces}</strong>
                        </Typography>
                    </Stack>
                    {/* <Stack direction="row">
                        <Typography variant="body1">
                            Donation: <strong>{content?.donation}</strong>
                        </Typography>
                    </Stack> */}
                    <Stack direction="row">
                        <Typography variant="body1">
                            Status : <strong>{content?.status}</strong>
                        </Typography>
                    </Stack>
                </Box>
            </CardContent>
        </Card>
    );
};

export { InnerCard };
